"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditasIcon = CreditasIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function CreditasIcon(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.241 10.197c0 .214-.068.377-.068.377-1.115 3.081-4.035 5.15-7.27 5.15a7.6 7.6 0 01-3.084-.652s-1.336.652-3.076.652C3.467 15.724 0 12.204 0 7.862 0 3.52 3.467 0 7.743 0c1.779 0 3.076.652 3.076.652A7.6 7.6 0 0113.903 0c3.235 0 6.155 2.07 7.27 5.15 0 0 .068.163.068.377a.838.838 0 01-.144.484c-.189.27-.517.438-.89.44h-5.054c-.84 0-1.187-.986-1.187-.986a6.733 6.733 0 00-3.145-3.587 6.775 6.775 0 00-3.573 5.984 6.775 6.775 0 003.573 5.984 6.733 6.733 0 003.145-3.587s.347-.986 1.188-.986h5.052c.374.002.703.17.89.44a.838.838 0 01.145.485zM14.96 4.816a7.891 7.891 0 00-2.822-3.492 6.593 6.593 0 011.825-.258c2.734 0 5.208 1.705 6.223 4.264h-4.664c-.366 0-.562-.514-.562-.514zM1.055 7.796c.001-3.711 2.98-6.73 6.642-6.73.619 0 1.224.089 1.802.255a7.863 7.863 0 00-3.386 6.474A7.863 7.863 0 009.5 14.27a6.514 6.514 0 01-1.802.255c-3.662 0-6.64-3.019-6.642-6.73zM12.138 14.4a7.892 7.892 0 002.822-3.492s.196-.514.562-.514h4.664c-1.015 2.559-3.489 4.264-6.223 4.264a6.6 6.6 0 01-1.825-.258z",
    fill: "#1B7"
  }), (0, _core.jsx)("mask", {
    id: "creditasIcon_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, (0, _core.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.241 10.197c0 .214-.068.377-.068.377-1.115 3.081-4.035 5.15-7.27 5.15a7.6 7.6 0 01-3.084-.652s-1.336.652-3.076.652C3.467 15.724 0 12.204 0 7.862 0 3.52 3.467 0 7.743 0c1.779 0 3.076.652 3.076.652A7.6 7.6 0 0113.903 0c3.235 0 6.155 2.07 7.27 5.15 0 0 .068.163.068.377a.838.838 0 01-.144.484c-.189.27-.517.438-.89.44h-5.054c-.84 0-1.187-.986-1.187-.986a6.733 6.733 0 00-3.145-3.587 6.775 6.775 0 00-3.573 5.984 6.775 6.775 0 003.573 5.984 6.733 6.733 0 003.145-3.587s.347-.986 1.188-.986h5.052c.374.002.703.17.89.44a.838.838 0 01.145.485zM14.96 4.816a7.891 7.891 0 00-2.822-3.492 6.593 6.593 0 011.825-.258c2.734 0 5.208 1.705 6.223 4.264h-4.664c-.366 0-.562-.514-.562-.514zM1.055 7.796c.001-3.711 2.98-6.73 6.642-6.73.619 0 1.224.089 1.802.255a7.863 7.863 0 00-3.386 6.474A7.863 7.863 0 009.5 14.27a6.514 6.514 0 01-1.802.255c-3.662 0-6.64-3.019-6.642-6.73zM12.138 14.4a7.892 7.892 0 002.822-3.492s.196-.514.562-.514h4.664c-1.015 2.559-3.489 4.264-6.223 4.264a6.6 6.6 0 01-1.825-.258z",
    fill: "#fff"
  })));
}

CreditasIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CreditasIcon"
};